import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const HistoryFilters = ({ filters, onFilterChange, friends, totalCount }) => {
  const statusOptions = [
    { value: 'all', label: 'Todos los estados' },
    { value: 'pending', label: 'Pendientes' },
    { value: 'active', label: 'Activos' },
    { value: 'completed', label: 'Completados' },
    { value: 'cancelled', label: 'Cancelados' }
  ];

  const metricOptions = [
    { value: 'all', label: 'Todas las categorías' },
    { value: 'gym_workouts', label: 'Entrenamientos' },
    { value: 'calories_limit', label: 'Calorías' },
    { value: 'sleep_hours', label: 'Sueño' },
    { value: 'water_intake', label: 'Hidratación' },
    { value: 'daily_steps', label: 'Pasos' },
    { value: 'daily_minimum', label: 'Actividad Mínima' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'Todo el tiempo' },
    { value: 'week', label: 'Última semana' },
    { value: 'month', label: 'Último mes' },
    { value: 'quarter', label: 'Últimos 3 meses' },
    { value: 'year', label: 'Último año' }
  ];

  const sortOptions = [
    { value: 'date_desc', label: 'Más recientes' },
    { value: 'date_asc', label: 'Más antiguos' },
    { value: 'status', label: 'Por estado' }
  ];

  const opponentOptions = [
    { value: 'all', label: 'Todos los oponentes' },
    ...friends?.map(friend => ({
      value: friend?.id,
      label: friend?.full_name
    }))
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange({ [key]: value });
  };

  const handleResetFilters = () => {
    onFilterChange({
      status: 'all',
      opponent: 'all',
      metric: 'all',
      dateRange: 'all',
      sortBy: 'date_desc'
    });
  };

  const hasActiveFilters = 
    filters?.status !== 'all' || 
    filters?.opponent !== 'all' || 
    filters?.metric !== 'all' || 
    filters?.dateRange !== 'all' ||
    filters?.sortBy !== 'date_desc';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="p-6 bg-card rounded-xl border-2 border-border"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Filtros</h3>
          <span className="px-2 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium">
            {totalCount} resultados
          </span>
        </div>
        {hasActiveFilters && (
          <button
            onClick={handleResetFilters}
            className="text-sm text-primary hover:text-primary/80 font-medium flex items-center space-x-1 transition-colors"
          >
            <Icon name="X" size={14} />
            <span>Limpiar filtros</span>
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Status Filter */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            Estado
          </label>
          <Select
            value={filters?.status}
            onChange={(e) => handleFilterChange('status', e?.target?.value)}
            options={statusOptions}
            className="w-full"
          />
        </div>

        {/* Opponent Filter */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            Oponente
          </label>
          <Select
            value={filters?.opponent}
            onChange={(e) => handleFilterChange('opponent', e?.target?.value)}
            options={opponentOptions}
            className="w-full"
          />
        </div>

        {/* Metric Filter */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            Categoría
          </label>
          <Select
            value={filters?.metric}
            onChange={(e) => handleFilterChange('metric', e?.target?.value)}
            options={metricOptions}
            className="w-full"
          />
        </div>

        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            Período
          </label>
          <Select
            value={filters?.dateRange}
            onChange={(e) => handleFilterChange('dateRange', e?.target?.value)}
            options={dateRangeOptions}
            className="w-full"
          />
        </div>

        {/* Sort Filter */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            Ordenar por
          </label>
          <Select
            value={filters?.sortBy}
            onChange={(e) => handleFilterChange('sortBy', e?.target?.value)}
            options={sortOptions}
            className="w-full"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default HistoryFilters;